/**
 * Orval mutator for User Management OpenAPI client (`libs/api-user-mgt/generated`).
 * Separate instance from main Raptor REST (`libs/api-rest`) so UM can target a different host.
 * Auth headers match main REST via {@link attachOrvalAuthRequestInterceptor}.
 */
import { attachOrvalAuthRequestInterceptor } from '@/libs/api-rest/orvalAuthInterceptor';
import type { ITokenProvider } from '@/libs/api-rest/token-provider.interface';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import axios from 'axios';

let tokenProvider: ITokenProvider | null = null;
let userManagementOrvalAxios: ReturnType<typeof axios.create> | null = null;

/**
 * Initialize UM REST axios. Call once during app bootstrap (after auth services exist).
 * Prefer `VITE_UM_API_BASE_URL` for the microservice; falls back to `VITE_APP_API_URL` for local mock-api.
 */
export function initializeUserManagementAxiosInstance(provider: ITokenProvider, baseURL: string): void {
  if (!baseURL || baseURL.trim() === '') {
    throw new Error('User Management API base URL is not defined or empty');
  }

  tokenProvider = provider;
  userManagementOrvalAxios = axios.create({ baseURL });
  attachOrvalAuthRequestInterceptor(userManagementOrvalAxios, () => tokenProvider);
}

/** Mutator used by Orval-generated UM clients. */
export const axiosInstance = <T = unknown, E = unknown>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<T, E>> => {
  if (!userManagementOrvalAxios) {
    throw new Error('User Management axios is not initialized. Call initializeUserManagementAxiosInstance() during app startup.');
  }

  return userManagementOrvalAxios.request<T, AxiosResponse<T, E>>({
    ...config,
    ...options
  });
};
